import { rawTransform } from 'src/services/skuit/utils'

import { Profile } from 'src/api/models'

import { API, CustomAxiosConfig } from './types'

export class ProfileAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  me = async (config: CustomAxiosConfig = {}): Promise<Profile> => {
    const response = await this.api.get('/accounts/me', config)
    return rawTransform(Profile)(response.data)
  }

  patch = async (data: any, config: CustomAxiosConfig = {}): Promise<Profile> => {
    const response = await this.api.patch('/accounts/me', data, config)
    return rawTransform(Profile)(response.data)
  }

  uploadProfileImage = async (file: File, config?: CustomAxiosConfig): Promise<null> => {
    const form = new FormData()
    form.append('file', file)
    const axiosConfig = {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    await this.api.put('/accounts/me/profile-image-upload', form, axiosConfig)
    return null
  }
}
